<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <br>
            <span style="text-align: center">
                <header-title title="รายการ RR"></header-title>
            </span>
            <div class="row">
                <div class="col-sm-6">
                    <!--start date-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            วันที่
                        </label>
                        <div class="col-sm-8">
                            <input class="form-control"
                                   disabled
                                   v-model="data_detail.date"
                                   type="date"
                            />
                        </div>
                    </div>
                    <!--start vendor-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            รหัสผู้จำหน่าย
                        </label>
                        <div class="col-sm-8">
                            <multiselect
                                    v-model="data_detail.vendor"
                                    disabled
                                    :options="optionVendor"
                                    track-by="vendor_id"
                                    label="vendor_id"
                                    @input="searchByVendor(data_detail.vendor)"
                                    placeholder="เลือกผู้จำหน่าย">
                            </multiselect>
                        </div>
                    </div>
                    <!--Vendor data-->
                    <template v-if="data_detail.vendor">
                        <div class="form-group row">
                            <label
                                    class="col-sm-4 col-form-label text-capitalize text-right">
                                ผู้จำหน่าย
                            </label>
                            <div class="col-sm-8 col-form-label">
                                <p>
                                    {{ data_detail.vendor.first_name }}
                                    {{ data_detail.vendor.last_name }}
                                </p>
                                <p>{{ data_detail.vendor.address }}</p>
                                <p>โทร {{ data_detail.vendor.phone }}</p>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="col-sm-6">
                    <!--rr number-->
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เลขที่เอกสาร
                        </label>
                        <div class="col-sm-8">
                            <masked-input v-model="data_detail.RR_number"
                                          mask="RR111111111"
                                          placeholder="เลข RR"
                                          type="text"
                                          class="form-control"/>
                        </div>
                    </div>
                    <!--credit day-->
                    <!--<div class="form-group row">-->
                        <!--<label class="col-sm-4 col-form-label text-capitalize text-right">-->
                            <!--เครดิต-->
                        <!--</label>-->
                        <!--<div class="col-sm-8">-->
                            <!--<input class="form-control"-->
                                   <!--v-model="data_detail.credit_day"-->
                                   <!--type="number"-->
                                   <!--style="width: 150px"-->
                                   <!--placeholder="30 วัน"-->
                            <!--/>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--&lt;!&ndash;payment date&ndash;&gt;-->
                    <!--<div class="form-group row">-->
                        <!--<label class="col-sm-4 col-form-label text-capitalize text-right">-->
                            <!--วันที่กำหนดชำระ-->
                        <!--</label>-->
                        <!--<div class="col-sm-8">-->
                            <!--<input class="form-control"-->
                                   <!--v-model="data_detail.payment_date"-->
                                   <!--type="date"-->
                            <!--/>-->
                        <!--</div>-->
                    <!--</div>-->
                </div>
                <br>
            </div>
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">#ใบจอง</th>
                    <th scope="col">มีภาษี</th>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวนสินค้า</th>
                    <th scope="col">ค้างส่ง</th>
                    <th scope="col" width="100px">ส่ง-pack</th>
                    <th scope="col">ราคา</th>
                    <th scope="col">จำนวนเงินรวมทั้งหมด</th>
                    <td scope="col">สถานะ</td>
                </tr>
                </thead>
                <tbody>
                <template v-for="data in data_detail.details">
                    <tr>
                        <td>{{data.po_number}}</td>
                        <td>
                            <span v-if="data.purchase_order.status_tax " style="color: #00a699;">
                                มีภาษี
                            </span>
                            <span v-else style="color: red">ไม่มีภาษี</span>
                        </td>
                        <td>
                            <template v-if="data.material">
                                {{data.material.code}}
                            </template>
                            <template v-else>
                                <p>-</p>
                            </template>
                        </td>
                        <td>
                            <template v-if="data.material">
                                {{data.material.name}}
                            </template>
                            <template v-else>
                                <p>-</p>
                            </template>
                        </td>
                        <td>{{data.quantity}}</td>
                        <td>{{data.remaining_pack}}</td>
                        <td>{{data.receive_pack}}</td>
                        <td>{{data.price | currency}}</td>
                        <td>{{data.total | currency}}</td>
                        <td>
                            <p v-if="data.status==2" style="color: red">
                                ดำเนินการเสร็จสิ้น
                            </p>
                            <p v-else-if="data.status==3" style="color: green">
                                เกินจำนวน
                            </p>
                            <p v-else>-</p>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
            <br>
            <b-row style="padding-right: 35px">
                <div class="float-right; text-right" style="margin-left: auto;">
                    <table style="font-size: 18px ; text-align: right">
                        <tr>
                            <td width="150px">รวมทั้งหมด :</td>
                            <td width="150px">{{parseFloat(data_detail.total) - parseFloat(data_detail.tax_rate) | currency}} บาท</td>
                        </tr>
                        <tr>
                            <td width="150px">ภาษีมูลค่าเพิ่ม 7% :</td>
                            <td width="150px">{{data_detail.tax_rate | currency}} บาท</td>
                        </tr>
                        <tr>
                            <td width="150px">ส่วนลดอื่นๆ :</td>
                            <td width="150px">{{data_detail.other_discount ? data_detail.other_discount : 0 | currency}} บาท</td>
                        </tr>
                        <tr>
                            <td width="150px">รายจ่ายอื่นๆ :</td>
                            <td width="150px">{{data_detail.other_income ? data_detail.other_income : 0 | currency}} บาท</td>
                        </tr>
                        <tr>
                            <td width="150px">ยอดรวม :</td>
                            <td width="150px">{{data_detail.total | currency}} บาท</td>
                        </tr>
                    </table>
                </div>
            </b-row>
            <br/>
            <div class="col text-right">
                <button type="button" class="btn btn-success" @click="updateRROrder">
                    ยืนยันการแก้ไข
                </button>
            </div>
            <br>
        </div>
        <!--<pre class="alert alert-primary">{{ totalPrice }}</pre>-->
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import { mapState } from "vuex";
    import HeaderTitle from "../../HeaderTitle";
    import MaskedInput from 'vue-masked-input'

    export default {
        name: "rr-order-form-details",
        // props: {
        //     id: { default: null }
        // },
        components : {
            HeaderTitle,
            MaskedInput,
            Multiselect},
        data(){
            return {
                total : 0,
                inc_vat : 0,
                tax : 7,
                vat : 1.07,
                status_list : 1,
                details : [],
                PO_Details : [],
                items: [
                    {
                        text: "รายการสร้าง RR",
                        to: { name: "rr-list" }
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
            }
        },
        created(){
            if(!this.$route.query.id){
                this.$store.dispatch('RROrder/clearform')
            }else{
                this.$route.query.id = window.atob(this.$route.query.id);
                this.id = this.$route.query.id;
                this.getdetailsdata(this.$route.query.id);
            }
            this.$store.dispatch('Vendor/getVendorAll');
        },
        computed:{
            ...mapState({
                optionVendor:state=>{
                    return state.Vendor.vendorList;
                },
                data_detail : state=>{
                    return state.RROrder.data;
                },
                user :state=>{
                    return state.Auth.user;
                },
                totalPrice() {
                    this.total = this.data_detail.details.reduce((carry, detail) => {
                        return carry + detail.total
                    }, 0);
                    return this.total
                },
                totalSum(){
                    let sum = 0;
                    sum = parseFloat(this.totalPrice) + parseFloat(this.data_detail.tax_rate)
                    sum = sum || sum > 0 ? sum : 0;
                    return sum;
                }
            }),
        },
        methods:{
            getdetailsdata(id){
                this.$store.dispatch('RROrder/show',id)
            },
            searchByVendor(vendor){
                if(vendor){
                    let vendor_id = vendor.id;
                    this.$store.dispatch('RROrder/searchByVendor',vendor_id).then(()=>{
                    });
                }else{
                    this.$store.dispatch('RROrder/clearform')
                }
            },
            updateRROrder(){
                let id = this.data_detail.id;
                let data = {
                  RR_number :  this.data_detail.RR_number
                };
                this.$store.dispatch("RROrder/update",{
                    id,
                    data
                }).then(res=>{
                    if(!res) {
                        alert("เลข RR ซ้ำกัน กรุณากรอกเบขใหม่อีกครั้ง");
                    }else{
                        window.close();
                    }
                }).catch(err=>{
                    alert("บันทึกไม่สำเร็จ");
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    thead {
        background-color: gray;
    }
    tbody {
        background-color: white;
    }
</style>
